import API from './config'

export const ClientRiskDataAPI = {

    //Mercado, Enquadramentos, Benchmarks e Política gerados no servidor (ou lidos do cache)
    async buildData(clientId, month, year) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/client_risk_data/build?client_id=${clientId}&month=${month}&year=${year}`, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : null
            };
        }
    },

    async createData(clientId, month, year) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post(`/client_risk_data/createData`, {
                client_id: clientId,
                month: month,
                year: year,
            }, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },


    async getClientRiskData(clientId, month, year) {

        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/client_risk_data?client_id=${clientId}&month=${month}&year=${year}`, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async deleteDataByMonthAndYear(clientId, month, year) {

        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post(`/client_risk_data/deleteDataByMonthAndYear`, {
                client_id: clientId,
                month: month,
                year: year,
            }, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },




}